var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"banner",attrs:{"height":!_vm.$vuetify.breakpoint.mobile? 160:80}})
}
var staticRenderFns = []

export { render, staticRenderFns }